import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-wrapper" }
const _hoisted_2 = { class: "control-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_l_map, {
      ref: "map",
      zoom: _ctx.zoom,
      center: _ctx.center,
      "min-zoom": 1,
      "use-global-leaflet": true,
      class: "h-100 w-100",
      onReady: _ctx.onMapReady
    }, {
      default: _withCtx(() => [
        _createVNode(_component_l_tile_layer, {
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          "layer-type": "base",
          name: "OpenStreetMap"
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["zoom", "center", "onReady"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.zoom), 1 /* TEXT */)
  ]))
}